import {IOnInit} from "angular";
import {Optional} from "../../js/util/Optional";

export const ToggleButton = "tfToggle";

export function toggleButton() {
    return {
        template,
        transclude: true,
        bindings: {
            on: "<",
            onText: "@",
            offText: "@"
        },
        controller: ToggleComponentController,
        controllerAs: "ctrl"
    };
}

export class ToggleComponentController implements IOnInit {

    public on: boolean;
    public onText: string | null;
    public offText: string | null;

    public active = false;

    public $onInit(): void {
        this.onText = Optional.of(this.onText).orElse("On");
        this.offText = Optional.of(this.offText).orElse("Off");
    }
}

const template = `
    <button type="button" class="btn-md btn-clear" ng-class="ctrl.on ? 'active' : ''">
        <i ng-class="ctrl.on ? 'icon-toggle-on textTFOrange' : 'icon-toggle-off'"></i>
        <span class="add-btn-name" ng-transclude>
            {{ctrl.on ? ctrl.onText : ctrl.offText}}
        </span>
    </button>
`;
